//React
import { FunctionComponent, useEffect, useRef } from "react";

//Components
import TextFacet from "./controls/text-facet";
import SliderFacet from "./controls/slider-facet";
import RadioButtonFacet from "./controls/radio-button-facet";

import {
	drhFacetAmenity,
	drhFacetBathrooms,
	drhFacetBedrooms,
	// drhFacetBrand,
	drhFacetGarages,
	drhFacetHomeSeries,
	// drhFacetPopertyType,
	drhFacetPriceRange,
	drhFacetPropertyType,
	drhFacetSize,
	drhFacetStories,
} from "../constants/all-facets";

//App Hooks
import {
	useAppDispatch,
	useAppSelector,
} from "../../system/redux/hooks/redux-store-hooks";

//Actions
import { clearFacets, setFacetModalOpen } from "../redux/slices/facet-slice";

//Util
import {
	moneyFormatter,
	numberFormatter,
} from "../../system/constants/formatters/drh-formatters";
import { selectModalOpen } from "../redux/selectors/select-modal-open";

interface FacetModalProps {}

const FacetModal: FunctionComponent<FacetModalProps> = (props) => {
	const dispatch = useAppDispatch();

	const modalOpen = useAppSelector(selectModalOpen);

	const componentRef = useRef(null);

	useEffect(() => {
		if (!modalOpen) {
			return;
		}

		const handleClickOutside = (event) => {
			if (
				componentRef.current &&
				!componentRef.current.contains(event.target)
			) {
				// If the clicked element is not inside the component, close it
				dispatch(setFacetModalOpen(false));
			} else {
			}
		};

		document.addEventListener("mousedown", handleClickOutside); // Use 'mousedown' for better responsiveness

		return () => {
			// Clean up the event listener when the component unmounts
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [modalOpen]);

	if (!modalOpen) {
		return null;
	} else {
		//JSX
		return (
			<>
				<div className="lightbox-container" id="finder-filters" style={{ display: "block" }}>
					<div className="lightbox-backdrop"></div>
					<div className="lightbox" ref={componentRef}>
						<span
							className="close close-filters"
							onClick={() => dispatch(setFacetModalOpen(false))}
						>
							✕
						</span>
						<SliderFacet
							drhFacet={drhFacetPriceRange}
							controlId="priceTitle"
							formatter={moneyFormatter}
						/>
						<div className="title">
							<h3>Size</h3>
						</div>
						<span className="two-col-filters">
							<RadioButtonFacet drhFacet={drhFacetBedrooms} />
							<RadioButtonFacet drhFacet={drhFacetBathrooms} />
							<RadioButtonFacet drhFacet={drhFacetGarages} />
							<RadioButtonFacet drhFacet={drhFacetStories} />
						</span>
						<SliderFacet
							drhFacet={drhFacetSize}
							controlId="sqFootTitle"
							formatter={numberFormatter}
						/>
						<div className="title" id="moreFacets">
							<h3>More filters</h3>
						</div>
						<span className="two-col-filters">
							<TextFacet drhFacet={drhFacetPropertyType} />
							<TextFacet drhFacet={drhFacetAmenity} />
							<TextFacet drhFacet={drhFacetHomeSeries} />
						</span>
						<div className="flex filters-buttons">
							<button
								className="CoveoFacetReset clearFilters"
								onClick={() => dispatch(clearFacets())}
							>
								Clear all
							</button>
							<button
								className="btn close close-done"
								onClick={() => dispatch(setFacetModalOpen(false))}
							>
								Done
							</button>
						</div>
					</div>
				</div>
			</>
		);
	}
};
export default FacetModal;
